export const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/Login.vue'),
    meta: {
      title: 'Logga in'
    }
  },
  {
    path: '/sso/callback',
    name: 'sso-callback',
    component: () => import('./views/Callback.vue'),
    meta: {
      title: 'SSO'
    }
  }
]
